import React, { FC } from 'react'
import Modal from 'react-modal';


interface ModalProps {
    toggle: boolean;
    setToggle: (value: boolean) => void;
    title: string;
    modalContent: JSX.Element;
    clickedButtonOne: () => void;
    clickedButtonTwo: () => void;
    ButtonOneValue: string;
    ButtonTwoValue: string;
}

export const ModalPopover: FC<ModalProps> = props => {
    const { toggle, setToggle, title, modalContent, clickedButtonOne, clickedButtonTwo, ButtonOneValue, ButtonTwoValue } = props;

    const onRequestClose = () => {
        setToggle(false);
    };

    const customStyles = {
        content: {
            top: '40%',
            left: '5%',
            right: 'auto',
            bottom: 'auto',
            //   marginRight: '-50%',
            //   transform: 'translate(-50%, -50%)',
            border: '1px solid',
            minWidth: '10%',
            maxWidth: '90%',
            minHeight: '10vh',
            maxHeight: '90vh',
        },
    };

    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false} style={customStyles} className='Modal'>
            <div className="Modal__Head">
                <div className="flex-row d-flex justify-content-between">
                    <div>
                        <span className="icon close" onClick={() => setToggle(false)} />
                    </div>
                    <div>
                        <span><h6>{title}</h6></span>
                    </div>
                </div>
            </div>
            <form className="Modal__Body-mini">
                <div className="form-group">
                    {modalContent}
                </div>
                <div style={{ textAlign: 'center' }}>
                    {ButtonOneValue ? <input type='button' onClick={clickedButtonOne} value={ButtonOneValue} className="btn btn-gray" style={{ margin: '10px' }} /> : null}
                    {ButtonTwoValue ? <input type='button' onClick={clickedButtonTwo} value={ButtonTwoValue} className="btn btn-gray" style={{ margin: '10px' }} /> : null}
                </div>
            </form>
        </Modal>
    );
};